<template>
  <div class="leaveProcess">
    <div
      class="processOuterItem"
      v-for="(item, index) in processList"
      :key="index + 'DsfTeasLeaveProcess'"
    >
      <div class="title">
        <div class="line"></div>
        <div>{{ item.month }}</div>
      </div>
      <div class="typeListContent" :class="index == (processList.length - 1) ? 'typenopadding' : ''">
        <div
          class="innerItem"
          :class="innerIndex == (item.list.length - 1) ? 'nopadding' : ''"
          v-for="(innerItem, innerIndex) in item.list"
          :key="innerIndex + 'type'"
        >
          <div class="item">
            <div class="time">{{ innerItem.leaveDays }}</div>
            <div class="type">{{ innerItem.leaveType }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <img
      class="nodata"
      v-show="processList.length == 0"
      :src="require('_platform/assets/styles/themes/img/nodata2.png')"
      alt=""
    /> -->
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfTeasLeaveProcess",
  props: {
    processList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
});
</script>